import NotificationActions from '../../../actions/NotificationActions';
import GuestActions from '../../../actions/GuestActions';

import UserStore from '../../../stores/UserStore';

import { endPoints as EndPoints } from '../../../constants/GuestConstants';

import InputProfile from './InputProfile.react';
import { Fragment } from 'react';
import AjaxPromises from '../../../utils/AjaxPromises';

class AddSecondaryIdentification extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            confirmClear : false,
            loading : false,

            stateId : '',
            image   : false,
            name    : '',

            imageType : null,
            isImageValid : false,
        };

        this.onChange = this.onChange.bind(this);
        this.addImage = this.addImage.bind(this);
        this.save = this.save.bind(this);
        this.removeMjStateId = this.removeMjStateId.bind(this);
    }

    onChange(field, val) {
        this.setState({ [field] : val });
    }

    addImage(e) {
        var self = this;

        // String parse and deny any non-criteria image types
        var imageType = (e.target.files[0].type).split('/')[1]
        switch (imageType.toLowerCase()) {
            case 'jpg':
            case 'jpeg':
            case 'jfif':
            case 'png':
            case 'tiff':
            case 'gif':
                this.setState({
                    imageType : imageType,
                })
                break;

            default:
                this.setState({
                    image : false,
                }, () => {
                    NotificationActions.addNotification({type:'alert',body:'Please use jpg, jpeg, jfif, png, tiff, or gif files for uploading photos'})
                })
                return;
        }

        var reader = new FileReader();
        reader.readAsDataURL( e.target.files[0] );

        reader.onload = function(upload) {
            self.setState({ image : self.dataURItoBlob(upload.target.result) }, () => {
                // self.saveSecondaryId();
            });
        }.bind(this);
    }

    save() {
        if (!this.isValid()){
            NotificationActions.addNotification({type:'alert',body:'Name cannot be empty and/or an image has not been selected'})
            return;
        }

        var self = this;

        var formData            = UserStore.getApiData();
        formData.Guest_id       = this.props.guest.Guest_id;
        formData.StateId        = this.state.stateId;
        formData.Image          = this.state.image.toString();
        formData.Name           = this.state.name;
        formData.IdentityId     = 0;
        formData.ImageType      = this.state.imageType

        this.setState({ loading : true }, () => {
            AjaxPromises.POST(EndPoints.EDIT_SECONDARY_ID,
                formData).then(res => {

                    self.setState({ loading : false }, () => {
                        if (!res.Result) {
                            NotificationActions.addNotification({type:'error',body: res.Message})
                        } else {

                            self.setState({ image : false, name : '', stateId : '' })
                            NotificationActions.addNotification({type:'success',body:'Image saved successfully'})

                            this.props.onAddId();
                        }
                    });
                }
            );
        });
    }

    removeMjStateId() {
        var self = this;

        var formData            = UserStore.getApiData();
        formData.Guest_id       = this.props.guest.Guest_id;

        this.setState({ mjStateIdLoad : true }, () => {
            AjaxPromises.POST(EndPoints.REMOVE_SECONDARY_ID,
                formData).then(res => {
                    if (res.Result === 'false') {
                        NotificationActions.addNotification({type:'error',body:'Image not removed'})
                    } else {
                        self.setState({ confirmClear : false, driversLicenseImg : false }, () => {
                            NotificationActions.addNotification({type:'success',body:'Image removed successfully'})

                            GuestActions.loadFullGuest(self.props.guest.Guest_id);
                        })
                    }
                }
            );
        });
    }

    dataURItoBlob(dataURI) {
        var byteString = false;

        var byteString;
        if (dataURI.split(',')[0].indexOf('base64') >= 0) {
            byteString = dataURI.split(',')[1];
        }

        return byteString;
    }

    isValid() {
        return this.state.image && this.state.name.length > 0 && !this.props.guest.IsAnonymous;
    }

    render() {
        var self  = this;

        var guest = this.props.guest;

        var image = this.state.image;
        var valid = this.isValid();

        return (

            <div className='row'>

                <div className='col-6'>
                    { this.state.image ?
                        <img
                            src={'data:image/png;base64, '+this.state.image}
                            className='view-identification__image' />
                    :
                        <img
                            src='/assets/id_placeholder.png'
                            className='view-identification__image' />
                    }
                </div>

                <div className='col-6'>
                    <div className='row'>
                        <div className='col-12'>

                            <InputProfile
                                field='name'
                                disabled={guest.IsAnonymous}
                                value={this.state.name}
                                placeHolder='Name'
                                onChange={this.onChange} />

                            <InputProfile
                                field='stateId'
                                disabled={guest.IsAnonymous}
                                value={this.state.stateId}
                                placeHolder='Number'
                                onChange={this.onChange} />

                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-12'>
                            {this.state.loading ?
                                <i className='fa fa-spinner fa-pulse' /> :
                                <Fragment>
                                    <div
                                        className={'btn-green add-identification__btn ' + (!guest.IsAnonymous ? '' : 'btn-green__disabled')}
                                        onClick={() => { 
                                            if (!guest.IsAnonymous) {
                                                $('#add-identification').click(); 
                                            }
                                        } }>

                                        SELECT IMAGE
                                    </div>

                                    <div
                                        className={'btn-green view-identification__btn '+(valid ? '' : 'btn-green__disabled')}
                                        onClick={!guest.IsAnonymous ? this.save : null}>

                                        SAVE
                                    </div>
                                </Fragment>
                            }
                            

                            <input
                                type='file'
                                accept='.jpg,.jfif,.jpeg,.png,.tiff,.gif'
                                id='add-identification'
                                className='view-identification__file'
                                onChange={this.addImage} />
                        </div>
                    </div>

                    { this.state.confirmClear &&
                        <div className='popup'>
                            <div className='popup__content view-identification__clear'>
                                <div className='popup-header'>
                                    CLEAR IMAGE
                                    <div
                                        className='popup-close'
                                        onClick={() => { this.setState({ confirmClear : false }) }}>

                                        <i className='fa fa-times' aria-hidden='true' />
                                    </div>
                                </div>

                                <button
                                    onClick={() => { this.setState({ confirmClear : false }) }}>

                                    CANCEL
                                </button>

                                <button
                                    onClick={self.removeMjStateId}>

                                    CLEAR
                                </button>
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default AddSecondaryIdentification;


// WEBPACK FOOTER //
// ./ui_src/app/components/profile/view/AddSecondaryIdentification.react.jsx